import React, { Component } from "react";
import "./rating.css";

export default class Rating extends Component {
  constructor(props) {
    super(props);
  }

  renderStars() {
    var _this = this;
    var count = this.props.count;
    var rating = this.props.rating;
    var starWidth = this.props.starWidth !== null ? this.props.starWidth : 50;
    var totalWidth = starWidth * count;
    var ratingWidth = ((rating * totalWidth) / count) - 2;
    if (rating === null || rating === 0) {
      ratingWidth = 0;
    };

    var stars = [];
    for (var i = 0; i < count; i++) {
      stars.push(<li key={i} onClick={() => _this.props.onSelect()} style={{width: starWidth + "px", height: starWidth + "px"}}></li>)
    };

    return (<div className="rdp-component-rating-stars-container" style={{width: totalWidth + "px", height: starWidth + "px"}}>
      <div className="rdp-component-rating-stars-background" style={{width: ratingWidth + "px"}}></div>
      <ul className="rdp-component-rating-stars" style={{width: totalWidth + "px"}}>
        {stars}
      </ul>
    </div>);
  }

  renderTitle() {
    var title = this.props.title;
    if (title) {
      return <span className="rdp-component-rating-title">{title}</span>;
    };
  }

  renderRatingValue() {
    var rating = this.props.rating;
    
    if (this.props.showRatingValue !== null && this.props.showRatingValue) {
      return (<span className="rdp-component-rating-value">{rating}</span>);
    } else {
      return "";
    }
  }

  render() {
    return (
      <div className="rdp-component-rating">
        {this.renderTitle()}
        {this.renderStars()}
        {/* {this.renderRatingValue()} */}
      </div>
    );
  }
}